import React, { Component } from "react";
import _ from 'lodash';
import { Icon, Dropdown, Image, Input } from "semantic-ui-react";
import { Container } from 'react-smooth-dnd'
import TreeView from "@zippytech/react-toolkit/TreeView";
import "@zippytech/react-toolkit/TreeView/index.css";
import MenuNode from "./MenuNode";
import { dispatch } from "@rematch/core";
import InlineEdit from '../OrganizationTree/InlineEdit';
import EllipsisTooltip from '../../../../../common/EllipsisTooltip';
import ImageAvater from '../../../../../drive/Components/ImageAvater';
class SimpleMappingTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateTime: new Date(),

    };
  }

  onSelectionChange(selectedMap) {
    if (_.has(selectedMap, "node.label.props.id")) {
      dispatch.initiatives.showResourecePane("Communities");
      dispatch.initiatives.splitAt("60%");
      dispatch.initiatives.setSuborganizationData({})
      dispatch.initiatives.getSelectedCommunityAsync(selectedMap.node.label.props.id);
      dispatch.initiatives.setIdToCenterPosition(selectedMap.node.label.props.id);
    }
    return;
  }
  selectAccountableForCommunity = (associatedCommunity, e, data) => {
    if (associatedCommunity.isRaciUpdated) {
      this.props.setChangeAccountableConfirmationModalOpen();
      this.props.setAssociatedCommunity(associatedCommunity);
      this.props.setAssignee(data.value)
      this.props.setManagers(this.props.managers);
      this.props.setMembers(this.props.members);
    }
    else {
      dispatch.initiatives.updateCommunity({ communityId: associatedCommunity._id, accountable: data.value, assigningUser: true, initiativeId: associatedCommunity.initiativeId })
      dispatch.initiatives.setAccountableForCommunity({ communityId: associatedCommunity._id, accountUserId: data.value.accountUserId, option: 1 });
      dispatch.initiatives.setAccountableForCommunityProps({ communityId: associatedCommunity._id, accountUser: data.value, option: 1, childCommunities: this.props.childCommunities });
      dispatch.initiatives.getTeamMappingData({ organizationId: this.props.selectedOrganisation.id, initiativeId: this.props.match.params.initiativeId, stopProcessing: this.props.stopProcessing, teamId: this.props.selectedDataById.teamId });
      this.props.stopProcessing();
    }

  }
  render() {
    const { label, id, dataChanged, validatioFunction, status, setUniqueId } = this.props;
    let length = this.props.selectedDataById.communities.filter((node) => { return !node.isLeafNode }).length;
    let treeLabelWithColor;
    let components = [];
    const thisObject = this;
    let windowDimension = this.props.componentDesignerDimension;
    let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 280;
    return (
      <div style={{ maxHeight: designerHeight, minHeight: designerHeight, overflow: "auto", padding: '0 10px' }}>
        
        <div style={{'background': "#ffffff"}}> 
        {this.props.selectedTeam && this.props.selectedTeam.name &&
          <InlineEdit
                  activeClassName="editing"
                  text={this.props.selectedTeam.name}
                  paramName="message"
                  data={{ id }}
                  change={dataChanged}
                  validationFunction={validatioFunction}
                  status={status}
                  elementType={this.props.element}
                  isDisabled={true}
                  managers={this.props.managers}
                  style={{
                    minWidth: 150,
                    width: "100%",
                    display: 'inline-flex',
                    margin: 0,
                    padding: 5,
                    fontSize: 'inherit',
                    outline: 0,
                    //borderBottom: this.props.associatedCommunity && this.props.associatedCommunity.length > 0 ? "1px solid #f3f7fb" : "none"
                  }}
                />
        }
        {this.props.selectedTeam && this.props.selectedTeam.name && this.props.childCommunities && this.props.childCommunities.length > 0 &&
              this.props.childCommunities.map((associatedCommunity, index) => {
                return <div key={index} style={{ height: '36px' }} >
                  <div key={index} style={{ display: 'flex', justifyContent:'space-between'}}>
                    <div key={associatedCommunity._id}
                      style={{ borderLeft: "4px solid " + associatedCommunity.tagColor, margin: "1px 0 1px 10px", padding: "5px", width: 'calc(100% - 280px)'}}>
                      <EllipsisTooltip
                        name={associatedCommunity.name}
                        // width="100%"
                        style={{ width: '100%' }} />
                    </div>
                    <div className="rightBox">
                      <div style={{ width: '270px' }}>
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          <span className='f_12'>Assignee</span>
                          <Dropdown
                            selection
                             direction="downward"
                             upward={false}
                            text={associatedCommunity.accountable ?
                              <div syle={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                                <ImageAvater user={associatedCommunity.accountable} imageStyle="mar_lr_5" className="f_8 w_16 h_16 pad_2 mar_lr_5" />
                                <EllipsisTooltip name={associatedCommunity.accountable.firstName + " " + associatedCommunity.accountable.lastName} />
                              </div>
                              :
                              <div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                                <ImageAvater user={this.props.managers[0]} imageStyle="mar_lr_5" className="f_8 w_16 h_16 pad_2 mar_lr_5" />
                                {/* <span className="user-dropdown-name">{this.props.managers[0].firstName + " " + this.props.managers[0].lastName} */}
                                {/* </span> */}
                                <span 
                                className="user-dropdown-name" 
                                style={{ 
                                  whiteSpace: 'nowrap', 
                                  overflow: 'hidden',   
                                  textOverflow: 'ellipsis', 
                                  maxWidth: 'calc(100% - 25px)',
                                }}
                              >
                                {`${this.props.managers[0].firstName} ${this.props.managers[0].lastName}`}
                              </span>
                              </div>
                            }
                            style={{
                              width: '150px',
                              minWidth: '150px',
                              display: 'flex',
                              justifyContent: 'space-between',
                            }}
                            onClick={this.searchUsers}
                            className="userSelectionDropdown"
                            floating
                            labeled
                          >
                            <Dropdown.Menu style={{}}>
                              <Input focus placeholder='Search...' onChange={this.searchUsers} onClick={e => e.stopPropagation()} value={this.state.searchText} />

                              {
                                this.props.managers.length > 0 ?
                                  <React.Fragment>
                                    <Dropdown.Divider />
                                    <Dropdown.Header content='Managers' />
                                    <Dropdown.Divider />
                                    {this.props.managers.map((manager, i) => {
                                      return <Dropdown.Item
                                        key={i}
                                        className="dropdownItems f_11"
                                        // image={{ avatar: true, src: manager.profilePic, className: 'float-left' }} 
                                        text={
                                          <div>
                                            <ImageAvater user={manager} imageStyle="mar_lr_5" className="f_8 w_16 h_16 pad_2 mar_lr_5 " />
                                            <EllipsisTooltip name={manager.firstName + " " + manager.lastName} />
                                          </div>
                                        }
                                        onClick={(event, data) => this.selectAccountableForCommunity(associatedCommunity, event, data)}
                                        value={manager}
                                      />
                                    })}
                                  </React.Fragment> : null
                              }

                              {
                                this.props.members.length > 0 ?
                                  <React.Fragment>
                                    <Dropdown.Divider />
                                    <Dropdown.Header content='Members' />
                                    <Dropdown.Divider />
                                    {this.props.members.map((member, i) => {
                                      return <Dropdown.Item
                                        key={i}
                                        className="dropdownItems f_11"
                                        // image={{ avatar: true, src: member.profilePic, className: 'float-left' }}
                                        text={<div> <ImageAvater user={member} imageStyle="mar_lr_5" className="f_8 w_16 h_16 pad_2 mar_lr_5" /><EllipsisTooltip name={member.firstName + " " + member.lastName} /></div>}
                                        onClick={(event, data) => this.selectAccountableForCommunity(associatedCommunity, event, data)}
                                        value={member} />
                                    })}
                                  </React.Fragment> :
                                  null
                              }

                              {
                                this.props.managers.length < 1 && this.props.members.length < 1 ?
                                  <React.Fragment>
                                    <Dropdown.Divider />
                                    <Dropdown.Header> User doesn't exists. </Dropdown.Header>
                                  </React.Fragment> : null
                              }

                            </Dropdown.Menu>
                          </Dropdown>
                          {/* <Icon
                            name="close"
                            color="grey"
                            onClick={(e) => this.removeMapping(e, associatedCommunity._id)}
                            style={{ 'paddingLeft': '10px' }}
                          /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              })
            }
            </div>
      </div>
    );
  }
}

export default SimpleMappingTree;
